import { serviceMasterData } from '@spectee/resources/serviceMaster';
import { serviceLicenseSettingData } from '@spectee/resources/serviceLicenseSetting';

export const getServiceMasterData = () => {
  return serviceMasterData.filter(service => service.id !== 'common');
};

/**
 * Get Service Name by service id
 * @param id target
 * @returns
 */
export const getServiceNameById = (serviceId: string) => {
  const service = serviceMasterData.find(service => service.id === serviceId);
  return service ? service.name : '';
};

/**
 * Get License Name by service id and license key
 * @param serviceId Target service ID
 * @param licenseKey Target license key
 * @returns License name or an empty string if not found
 */
export const getLicenseNameByServiceIdAndLicenseKey = (
  serviceId: string,
  licenseKey: string
): string => {
  // Find the service in serviceLicenseSettingData by serviceId
  const service = serviceLicenseSettingData.find(
    service => service.serviceId === serviceId
  );

  // If the service exists, find the license by the licenseKey
  if (service) {
    const license = service.licenses.find(
      license => license.key === licenseKey
    );
    return license ? license.name : ''; // Return the license name or an empty string if not found
  }

  // If the service doesn't exist, return an empty string
  return '';
};
